const dashboard = { name: "Dashboard", icon: "mdi-view-dashboard-outline", route: "/home", path: null };

const managementGroups = [
  {
    name: "Cadastros e acessos",
    icon: "mdi-account-cog-outline",
    children: [
      { name: "Casos", icon: "mdi-account-file-outline", route: "/casos", path: "Client", permissions: ["clients.view"] },
      { name: "Administradores", icon: "mdi-account-supervisor-circle-outline", route: "/admins", path: "Admin", permissions: ["admins.view"] },
      { name: "Administradores (devedora)", icon: "mdi-domain", route: "/admins-devedora", path: "ClientUser", permissions: ["clientusers.view"] },
      { name: "Administradores (MP)", icon: "mdi-shield-account-outline", route: "/admins-mp", path: "MpUser", permissions: ["clientusers.view"] },
      { name: "Usuários do Juízo", icon: "mdi-gavel", route: "/admins-juizo", path: "JudiciaryUser", permissions: ["judiciaryusers.view"] },
      { name: "Esclarecimentos do Juízo", icon: "mdi-message-question-outline", route: "/esclarecimentos-juizo", path: "JudiciaryClarification", permissions: ["judiciaryusers.view"] },
      { name: "Cargos", icon: "mdi-account-supervisor-outline", route: "/cargos", path: "Role", permissions: ["roles.view"] },
    ],
  },
  {
    name: "Credores e representação",
    icon: "mdi-account-group-outline",
    children: [
      { name: "Credores", icon: "mdi-account-group-outline", route: "/credores", path: "User", permissions: ["users.view"] },
      { name: "Procuradores", icon: "mdi-account-tie-outline", route: "/procuradores", path: "Lawyer", permissions: ["lawyers.view"] },
      { name: "Pedidos dos credores", icon: "mdi-file-account-outline", route: "/pedidos-credores", path: "CreditorsRequests", permissions: ["creditorsrequests.view"] },
    ],
  },
  {
    name: "Créditos e habilitações",
    icon: "mdi-file-certificate-outline",
    children: [
      { name: "QGC", icon: "mdi-badge-account-horizontal-outline", route: "/qgc", path: "Qgc", permissions: ["usercreditors.view"] },
      { name: "Habilitações e divergências", icon: "mdi-sync-alert", route: "/divergencias", path: "Event", permissions: ["events.view"] },
      { name: "Revisão de crédito", icon: "mdi-file-document-refresh-outline", route: "/revisao-credito", path: "Event", permissions: ["events.view"] },
      { name: "Análise de ofício", icon: "mdi-file-search-outline", route: "/analise-oficio", path: "OfficioAnalysis", permissions: ["lawyers.view"] },
      { name: "Certidão de habilitação", icon: "mdi-account-group-outline", route: "/certidao-credito", path: "User", permissions: ["usercreditors.view"] },
      { name: "Certidões de crédito", icon: "mdi-file-certificate-outline", route: "/certidoes-credito", path: "IssuedCreditCertificate", permissions: ["usercreditors.view"] },
    ],
  },
  {
    name: "Processos judiciais",
    icon: "mdi-gavel",
    children: [
      { name: "Impugnações", icon: "mdi-gavel", route: "/impugnacoes", path: "Proceedings", permissions: ["proceedings.view"] },
      { name: "Outros processos", icon: "mdi-briefcase-search-outline", route: "/outros-processos", path: "OtherProceedings", permissions: ["otherproceedings.view"] },
    ],
  },
  {
    name: "Plano e pagamentos",
    icon: "mdi-file-sign",
    children: [
      { name: "Adesão ao plano", icon: "mdi-file-sign", route: "/adesao-plano", path: "PlanAdherence", permissions: ["events.view"] },
      { name: "Comprovantes de pagamento", icon: "mdi-receipt-text-check-outline", route: "/comprovantes-pagamento", path: "PaymentProof", permissions: ["paymentproofs.view"] },
    ],
  },
  {
    name: "Documentos e automações",
    icon: "mdi-folder-cog-outline",
    children: [
      { name: "Documentos", icon: "mdi-file-outline", route: "/documentos", path: "Document", permissions: ["clientdocs.view"] },
      { name: "Textos automáticos (RVC)", icon: "mdi-text-box-outline", route: "/textos-automaticos", path: "DynamicText", permissions: ["dynamictexts.view"] },
    ],
  },
];

const data = [
  {
    name: "Início",
    path: null,
    permissions: ["dashboard.view"],
    children: [dashboard],
  },
  {
    name: "Gestão",
    path: "Manager",
    permissions: ["manager.view"],
    children: managementGroups,
  },
  {
    name: "Relatórios",
    path: "Report",
    permissions: ["reportmanager.view"],
    children: [
      {
        name: "Relatórios e análises",
        icon: "mdi-chart-box-outline",
        children: [
          { name: "Análises", icon: "mdi-magnify-scan", route: "/analise-relatorio", path: "ReportAnalysis", permissions: ["reportanalysis.view"] },
          { name: "Relatórios", icon: "mdi-chart-box-outline", route: "/relatorio", path: "Report", permissions: ["reports.view"] },
          { name: "Arquivos", icon: "mdi-file-outline", route: "/arquivo-relatorio", path: "ReportFile", permissions: ["reportfiles.view"] },
          { name: "Modelos de relatórios", icon: "mdi-file-chart-outline", route: "/modelo-relatorio", path: "ReportType", permissions: ["reporttypes.view"] },
        ],
      },
    ],
  },
  {
    name: "Site",
    path: "Site",
    permissions: ["site.view"],
    children: [
      {
        name: "Atendimento e conteúdo",
        icon: "mdi-lifebuoy",
        children: [
          { name: "Ajuda", icon: "mdi-help-circle-outline", route: "/ajuda", path: "Help", permissions: ["faqs.view"] },
          { name: "Dúvidas", icon: "mdi-account-question-outline", route: "/faqs", path: "Faq", permissions: ["faqs.view"] },
          { name: "Banner de aviso", icon: "mdi-invoice-text-clock-outline", route: "/banner-aviso", path: "HomeBanner" },
        ],
      },
      {
        name: "Configurações do portal",
        icon: "mdi-cog-outline",
        children: [
          { name: "Modelos de documentos", icon: "mdi-file-sign", route: "/modelo-documentos", path: "TemplateDoc", permissions: ["documentmodels.view"] },
          { name: "Textos dinâmicos", icon: "mdi-file-chart-outline", route: "/textos-dinamicos", path: "DynamicInfo", permissions: ["dynamicinfos.view"] },
          { name: "Privacidade", icon: "mdi-file-document-check-outline", route: "/privacidade", path: "PrivacyInfo", permissions: ["privacy.view"] },
        ],
      },
    ],
  },
];

export default [...data];
